"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["add"] = "add";
  TranslationKey["added"] = "added";
  TranslationKey["buy"] = "buy";
  TranslationKey["buyProducts"] = "buyProducts";
  TranslationKey["choose"] = "choose";
  TranslationKey["chooseProductsToDiscount"] = "chooseProductsToDiscount";
  TranslationKey["chooseShade"] = "chooseShade";
  TranslationKey["chooseUpTo0ProductsWith1Discount"] = "chooseUpTo0ProductsWith1Discount";
  TranslationKey["chosenShades"] = "chosenShades";
  TranslationKey["discountedProduct"] = "discountedProduct";
  TranslationKey["done"] = "done";
  TranslationKey["dontMissOut"] = "dontMissOut";
  TranslationKey["getOffer"] = "getOffer";
  TranslationKey["itemToYourBasket"] = "itemToYourBasket";
  TranslationKey["itemsThatMadeYouEligibleForSpecialOffers"] = "itemsThatMadeYouEligibleForSpecialOffers";
  TranslationKey["noShadesChoosen"] = "noShadesChoosen";
  TranslationKey["outOfStock"] = "outOfStock";
  TranslationKey["productsGetOffer"] = "productsGetOffer";
  TranslationKey["productsInOffer"] = "productsInOffer";
  TranslationKey["productsThatMadeYouEligibleForThisOffer"] = "productsThatMadeYouEligibleForThisOffer";
  TranslationKey["productsWithDiscount"] = "productsWithDiscount";
  TranslationKey["qty"] = "qty";
  TranslationKey["replacement"] = "replacement";
  TranslationKey["seeAllItems"] = "seeAllItems";
  TranslationKey["setOfProducts"] = "setOfProducts";
  TranslationKey["specialOffer"] = "specialOffer";
  TranslationKey["total"] = "total";
  TranslationKey["youAdded"] = "youAdded";
  TranslationKey["yourOffers"] = "yourOffers";
  return TranslationKey;
}({});